import React, { useState } from 'react';
import { t as uiText } from '../../../i18n';
import { useLogout } from '../../auth/logout';
import { useEmailVerification } from '../EmailVerificationContext';
import ResendButton from './ResendButton';
import ChangeEmailButton from './ChangeEmailButton';
import EmailHelp from './EmailHelp';

/** 72時間経過後のロック画面。閉じられず、全ルートの上に表示される */
const EmailLockScreen: React.FC = () => {
  const { email, refresh } = useEmailVerification();
  const logout = useLogout();
  const [checking, setChecking] = useState(false);

  const onCheck = async () => {
    if (checking) return;
    setChecking(true);
    try {
      await refresh();
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="ev-lock" role="dialog" aria-modal="true" aria-labelledby="ev-lock-title">
      <div className="ev-lock-card">
        <h1 id="ev-lock-title" className="ev-title">
          {uiText('Email verification is required')}
        </h1>
        <p>
          {uiText(
            'To keep your account secure, notreu features are temporarily restricted.'
          )}
        </p>
        <p>{uiText('Please complete verification using the confirmation email sent to your registered address.')}</p>
        <p>{uiText('Once verification is complete, you can use the features again.')}</p>
        {email && (
          <p className="ev-email">
            <strong>{email}</strong>
          </p>
        )}
        <div className="ev-actions ev-actions-stack">
          <ResendButton />
          <ChangeEmailButton />
          <button type="button" className="ev-btn ev-btn-primary" onClick={onCheck} disabled={checking}>
            {checking ? uiText('Checking...') : uiText('I have completed verification')}
          </button>
          <button type="button" className="ev-btn ev-btn-quiet" onClick={() => void logout()}>
            {uiText('Log out')}
          </button>
        </div>
        <EmailHelp />
      </div>
    </div>
  );
};

export default EmailLockScreen;
